interface Props {
  current: number;
  total: number;
}

export default function ProgressBar({ current, total }: Props) {
  const pct = total === 0 ? 0 : Math.round((current / total) * 100);
  return (
    <div
      role="progressbar"
      aria-valuenow={current}
      aria-valuemax={total}
      aria-valuemin={0}
      className="h-2 w-full overflow-hidden rounded bg-surface-alt"
    >
      <div
        data-testid="progress-fill"
        className="h-full bg-brand transition-all"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
